import Page from './index';

export default { path: '/home/msgPush/channel', component: Page };
